import { AutocompleteOption } from "../../common/autocomplete/DotLegalAutocomplete";
import { Organization } from "../organizations/Organization.types";

export type ApplicationUser = {
    id?: number;
    name: string;
    email: string;
    phoneNumber: string;
    countryCode: string;
    userRoles: UserRole[];
    organizations: Organization[];
    countryAccess: string[];
    menuAccess: MenuAccess[];
};

export type ConfigurableApplicationUser = ApplicationUser & { new: boolean };

export type UserRole = {
    name: "Client" | "Employee" | "Admin" | "Read only";
    id: string | number;
};

export enum MenuAccess {
    Trademarks = 0,
    Designs = 1,
    Copyrights = 2,
    Watches = 3,
    Renewals = 4,
    Disputes = 5,
    Costs = 6,
    PriceCalculator = 7,
}

export type MenuOption = {
    id: MenuAccess;
    name: string;
};

export type UserFilter = {
    organisations: Array<string>;
    userRoles: Array<string>;
    searchText?: string;
    pageSize: number;
    pageNumber: number;
    orderBy: string;
    orderByDescending: boolean;
};

export type UsersResponse = {
    users: ApplicationUser[];
    totalCount: number;
};

export type UserFilterOptions = UserAutocompleteOptions & {
    searchText?: string;
};

export type UserAutocompleteOptions = {
    organisations: AutocompleteOption<string>[];
    userRoles: AutocompleteOption<string>[];
};

export type UsersTableModel = ApplicationUser & {
    resendInvitation: boolean;
};
